import React from 'react';
import Layout from 'app/components/common/Layout';
import HeadInfo from 'app/components/common/HeadInfo';
import AdCenterListContainer from 'app/containers/encarcenter/AdCenterListContainer';

function AdCenterListPage() {
	return (
		<Layout
			title="엔카지점"
			useHeaderLogo
			useAside
			useFooter
			useServiceLink
			useSSR
		>
			<HeadInfo headTitle="엔카지점" />
			<AdCenterListContainer />
		</Layout>
	);
}

export default AdCenterListPage;
